import request from '@/utils/request'

const url = 'admin/user_money_adjust'

export function submitMoneyAdjust(data) {
  return request({
    url: `${url}/submit`,
    method: 'post',
    data
  })
}

export function listMoneyAdjust(data) {
  return request({
    url: `${url}/list`,
    method: 'post',
    data
  })
}

export function detailMoneyAdjust(data) {
  return request({
    url: `${url}/detail`,
    method: 'post',
    data
  })
}

export function level1Approve(data) {
  return request({
    url: `${url}/level1Approve`,
    method: 'post',
    data
  })
}

export function level2Approve(data) {
  return request({
    url: `${url}/level2Approve`,
    method: 'post',
    data
  })
}

export function pendingMoneyAdjustList(data) {
  return request({
    url: `${url}/pendingList`,
    method: 'post',
    data
  })
}

export function updateRejectedMoneyAdjust(data) {
  return request({
    url: `${url}/updateRejected`,
    method: 'post',
    data
  })
}

export function deleteRejectedMoneyAdjust(data) {
  return request({
    url: `${url}/deleteRejected`,
    method: 'post',
    data
  })
}
